"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _selectors = require("../../../redux/locationManager/selectors");

var _selectors2 = require("../../../redux/login/selectors");

/**
 * Filters the locations by OrgId. Will also include non-active locations if the current user is an Admin
 * @param orgId The organization id to filter by
 * @returns {Location[]} filtered list of locations.
 */
function useOrgLocationsFilter(orgId) {
  var locationList = (0, _reactRedux.useSelector)(_selectors.locationListSelector);

  var _useLoginSelector = (0, _selectors2.useLoginSelector)(),
      admin = _useLoginSelector.claims.admin;

  return (0, _react.useMemo)(function () {
    return locationList.filter(function (location) {
      return admin || location.orgId === orgId;
    }).sort(function (l1, l2) {
      if (l1.active && !l2.active) {
        return 1;
      } else if (!l1.active && l2.active) {
        return -1;
      }

      return l1.name.localeCompare(l2.name);
    });
  }, [locationList, orgId, admin]);
}

var _default = useOrgLocationsFilter;
exports.default = _default;